<template>
  <div
    :id="fatherDivId"
    class="field"
    @click.stop="downLoad($event)"
    :style="{
      '--mixtmt_echarts_footBallPlaygroundColor':
        currThemeObj.cssStyle.echarts_footBallPlaygroundColor,
      '--mixtmt_echarts_footBallPlaygroundBgColor':
        currThemeObj.cssStyle.echarts_footBallPlaygroundBgColor,
    }"
  >
    <canvas class="canvas" :id="canvasId"></canvas>
    <div v-show="showPlayName" class="comment" :id="commentId">
      <div class="comment_t">平均传球距离</div>
      <div class="comment_t_vertical_scale"></div>
      <!-- <span class="number" v-if="scaleArray.length > 0" style="right: 11%;bottom: 4.5%">{{scaleArray[0]}}</span>
          <span class="number" v-if="scaleArray.length > 0" style="right: 8%;bottom: 4.5%">{{scaleArray[1]}}</span>
          <span class="number" v-if="scaleArray.length > 0" style="right: 5%;bottom: 4.5%">{{scaleArray[2]}}</span>
          <span class="number" v-if="scaleArray.length > 0" style="right: 2%;bottom: 4.5%">{{scaleArray[3]}}</span> -->
      <div class="comment_number">
        <span class="number" v-if="scaleArray.length > 0">
          {{ scaleArray[0] }}
        </span>
        <span class="number" v-if="scaleArray.length > 0">
          {{ scaleArray[1] }}
        </span>
        <span class="number" v-if="scaleArray.length > 0">
          {{ scaleArray[2] }}
        </span>
        <span class="number" v-if="scaleArray.length > 0">
          {{ scaleArray[3] }}
        </span>
      </div>

      <div class="comment_t_text">弧度半径=该角度的传球次数</div>
    </div>
    <div class="right_img" v-if="isVerticalImg">
      <div class="r_i_t">弧度半径=该角度的传球次数</div>
      <div class="r_i_b">
        <div class="r_i_b_vertical">
          <div class="r_i_b_vertical_text">
            <span class="number_1" v-if="scaleArray.length > 0">
              {{ scaleArray[3] }}
            </span>
            <span class="number_1" v-if="scaleArray.length > 0">
              {{ scaleArray[2] }}
            </span>
            <span class="number_1" v-if="scaleArray.length > 0">
              {{ scaleArray[1] }}
            </span>
            <span class="number_1" v-if="scaleArray.length > 0">
              {{ scaleArray[0] }}
            </span>
          </div>
          <div class="r_i_b_vertical_scale"></div>
        </div>
        <div class="r_i_b_text">平均传球距离</div>
      </div>
    </div>
  </div>
</template>

<script>
/*
  * 扇形图组件接入说明
  * 传入参数：
  * 1.sectorData 球队扇形图数据  Array  一个数组包含所有球员的所有扇形数据
  * 格式为 [{
  *       "player_id": id,
          "player_name": "球员名字",
          "passing_distance": 传球距离,
          "index": "0",
          "passing_angle": "扇形角度",
          "passing_times": 传球次数,
          "player_position_x": 球员坐标,
          "player_position_y": 球员坐标
  * }]
  * 2.showPlayName 是否显示球员名称 为true时显示，不传不显示
  *
  * 方法说明：
  * 1.导出图片方法为  savePng  在父组件调用可采用 $ref 的方式使用，传入参数为图片名称，使用png方式导出
  * */
// import _ from 'lodash'
import datas from './passingStyle.json'
import cup_base_data_mixin from '@mixins/cup_base_data'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'sector',
  mixins: [canvasToImage_base64_data_mixin, cup_base_data_mixin],
  data() {
    return {
      fatherDivId: Math.random(),
      canvasId: Math.random(),
      playerMap: {},
      maxDistance: 0,
      maxTimes: 0,
      ratio: 0,
      radiusScale: 0.1,
      isDb: true, // 双击禁止
      commentId: Math.random(),
      scaleArray: [],
      sectorData: null, // 临时文件
    }
  },
  props: {
    // 'sectorData':{},
    showPlayName: {
      type: Boolean,
      default: false,
    },
    isDownLoadImg: {
      default: false,
    },
    isVerticalImg: {
      default: false,
    },
  },
  created() {
    this.sectorData = datas.resultData[0]
  },
  watch: {
    sectorData: {
      handler: function () {
        this.changeRatio()
        this.render()
      },
      deep: true,
    },
  },
  methods: {
    downLoad(e) {
      if (!this.isDownLoadImg) {
        return
      }
      if (!this.isDb) {
        return
      }
      this.isDb = false
      this.$nextTick(() => {
        const el = e.target
        this.toImage.getOptions({
          el: el,
        })
      })
      setTimeout(() => {
        this.isDb = true
      }, 500)
    },
    changeRatio() {
      let canvas = document.getElementById(this.canvasId)
      let ctx = canvas.getContext('2d')
      // 屏幕的设备像素比
      let devicePixelRatio = window.devicePixelRatio || 1
      // 浏览器在渲染canvas之前存储画布信息的像素比
      let backingStoreRatio =
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1
      // canvas的实际渲染倍率
      this.ratio = devicePixelRatio / backingStoreRatio
      let fatherDiv = document.getElementById(this.fatherDivId)
      // let fWidth = fatherDiv.offsetWidth - 12
      let fWidth = fatherDiv.offsetWidth
      let commentDiv = document.getElementById(this.commentId)

      canvas.style.width = fWidth + 'px'
      canvas.style.height = Math.floor((fWidth / 1614) * 1084) + 'px'
      // commentDiv.style.width = fWidth + 'px'
      // commentDiv.style.height = fWidth / 1614 * 1084 + 'px'
      // if (fWidth < 600) {
      //   commentDiv.style.fontSize = '6px'
      // } else if (fWidth >= 600 && fWidth < 1000) {
      //   commentDiv.style.fontSize = '10px'
      // } else if (fWidth >= 1000 && fWidth < 1200) {
      //   commentDiv.style.fontSize = '12px'
      // } else if (fWidth > 1200) {
      //   commentDiv.style.fontSize = '14px'
      // }
      canvas.width = fWidth * this.ratio
      canvas.height = Math.floor((fWidth / 1614) * 1084) * this.ratio
    },
    render() {
      let c = document.getElementById(this.canvasId)
      this.playerMap = {}
      c.height = c.height
      this.sectorData.forEach((point) => {
        let id = point.player_id
        let player_name = point.player_name
        // point.passing_distance = _.toNumber(point.passing_distance)
        point.passing_distance = point.passing_distance - 0
        if (point.passing_distance > this.maxDistance) {
          this.maxDistance = point.passing_distance
        }
        // point.passing_times = _.toNumber(point.passing_times)
        point.passing_times = point.passing_times - 0
        if (point.passing_times > this.maxTimes) {
          this.maxTimes = point.passing_times
        }
        // point.passing_angle = _.toNumber(point.passing_angle)
        point.passing_angle = point.passing_angle - 0
        if (!this.playerMap[id]) {
          // let single = {
          //   id: id,
          //   player_name: player_name,
          //   y: 100 - _.toNumber(point.player_position_x) * 10,
          //   x: _.toNumber(point.player_position_y) * 10,
          //   angle: [],
          // }
          let single = {
            id: id,
            player_name: player_name,
            y: 100 - (point.player_position_x - 0) * 10,
            x: (point.player_position_y - 0) * 10,
            angle: [],
          }
          single.angle.push(point)
          this.playerMap[id] = single
        } else {
          this.playerMap[id].angle.push(point)
        }
      })
      let minDistance = 5
      let max = Math.floor(this.maxDistance)
      let secondDis = Math.floor((max - minDistance) / 3) + 5
      let threeDis = Math.floor(((max - minDistance) / 3) * 2) + 5
      this.scaleArray = [minDistance, secondDis, threeDis, max]
      let x = 0
      for (let k in this.playerMap) {
        this.renderSingle(this.playerMap[k])
        x++
      }
    },
    renderSingle(data) {
      let canvas = document.getElementById(this.canvasId)
      let ctx = canvas.getContext('2d')
      let w = canvas.width
      let h = canvas.height
      if (this.showPlayName === true) {
        this.renderName(data)
      }
      data.angle.forEach((angle) => {
        let color = this.colorScale(angle.passing_distance)
        let radius =
          (h * this.radiusScale * angle.passing_times) / this.maxTimes +
          h * this.radiusScale * 0.1
        let startAngle = ((12 - (angle.passing_angle - 1)) / 12) * Math.PI * 2
        let endAngle = ((12 - angle.passing_angle) / 12) * Math.PI * 2
        ctx.beginPath()
        ctx.strokeStyle = 'white'
        ctx.fillStyle = color
        ctx.moveTo((data.x * w) / 100, (data.y * h) / 100)
        ctx.arc(
          (data.x * w) / 100,
          (data.y * h) / 100,
          radius,
          startAngle,
          endAngle,
          true
        )
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
      })
    },
    renderName(data) {
      let canvas = document.getElementById(this.canvasId)
      let ctx = canvas.getContext('2d')
      let w = canvas.width
      let h = canvas.height
      let player_name = data.player_name.replace(/(^\s*)|(\s*$)/g, '')
      let nameLen = player_name.length
      ctx.beginPath()
      ctx.fillStyle = '#ACB6C4'
      ctx.arc((data.x * w) / 100, (data.y * h) / 100, 2, 0, Math.PI * 2)
      ctx.fill()
      ctx.closePath()
      let radius = h * this.radiusScale
      let textX = (data.x * w) / 100 + radius
      let textY = (data.y * h) / 100 - radius
      if (textX > w * 0.95) {
        ctx.textAlign = 'center'
        textX = (data.x * w) / 100
        textY = (data.y * h) / 100 - radius - 10
      }
      if (textY < h * 0.05) {
        textY = (data.y * h) / 100
        textX = (data.x * w) / 100 + radius + 10
      }
      ctx.strokeStyle = '#ACB6C4'
      ctx.moveTo((data.x * w) / 100, (data.y * h) / 100)
      ctx.lineTo(textX - 13, textY)
      ctx.stroke()
      ctx.closePath()
      ctx.beginPath()
      ctx.fillStyle = '#D5DBE4'
      ctx.arc(textX, textY - 8, 13, Math.PI, Math.PI * 1.5) // 左上角
      ctx.arc(textX + nameLen * 15, textY - 8, 13, 1.5 * Math.PI, 2 * Math.PI) // 右上角
      ctx.arc(textX + nameLen * 15, textY - 4, 13, 0, 0.5 * Math.PI) // 右下角
      ctx.arc(textX, textY - 4, 13, 0.5 * Math.PI, Math.PI + 0.3) // 左下角
      ctx.fill()
      ctx.closePath()
      ctx.beginPath()
      ctx.textAlign = 'left'
      ctx.font = '16px sans-serif'
      ctx.fillStyle = '#184D3C'
      ctx.stroke()
      // let player_name = data.player_name.length > 5 ? data.player_name.substring(0, 4) + '...' : data.player_name // 溢出隐藏
      ctx.fillText(player_name, textX, textY)
      ctx.closePath()
    },
    colorScale(data) {
      let startColor = '#8FDCC7'
      let endColor = '#208F6F'
      let sColor = this.hexToRgb(startColor),
        eColor = this.hexToRgb(endColor)

      let rStep = ((eColor[0] - sColor[0]) * data) / this.maxDistance,
        gStep = ((eColor[1] - sColor[1]) * data) / this.maxDistance,
        bStep = ((eColor[2] - sColor[2]) * data) / this.maxDistance
      return this.rgbToHex([
        parseInt(rStep + sColor[0]),
        parseInt(gStep + sColor[1]),
        parseInt(bStep + sColor[2]),
      ])
    },
    hexToRgb(hex) {
      let rgb = []
      for (let i = 1; i < 7; i += 2) {
        rgb.push(parseInt('0x' + hex.slice(i, i + 2)))
      }
      return rgb
    },
    rgbToHex(rgb) {
      let hex = ((rgb[0] << 16) | (rgb[1] << 8) | rgb[2]).toString(16)
      return '#' + new Array(Math.abs(hex.length - 7)).join('0') + hex
    },
    refresh() {
      this.changeRatio()
      this.render()
    },
    savePng(fileName) {
      let play_name = fileName || '测试'
      let canvasElement = document.getElementById(this.canvasId)
      let MIME_TYPE = 'image/png'
      let imgURL = canvasElement.toDataURL(MIME_TYPE)
      let dlLink = document.createElement('a')
      dlLink.download = play_name
      dlLink.href = imgURL
      dlLink.dataset.downloadurl = [
        MIME_TYPE,
        dlLink.download,
        dlLink.href,
      ].join(':')
      document.body.appendChild(dlLink)
      dlLink.click()
      document.body.removeChild(dlLink)
    },
  },
  mounted() {
    if (this.showPlayName === true) {
      // let canvas = document.getElementById(this.canvasId)
      // let imgObj = new Image()
      // imgObj.src = require('../../static/imges/comment.png')
      // imgObj.onload = function () {
      //   let w = canvas.width
      //   let h = canvas.height
      //   let ctx = canvas.getContext('2d')
      //   ctx.drawImage(imgObj, 0, 0, w, h)
      // }
    }
    this.changeRatio()
    this.render()
  },
}
</script>

<style scoped lang="scss">
.field {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  background: var(--mixtmt_echarts_footBallPlaygroundBgColor);
  border-radius: 0.694vw;
  border: 0.416vw solid var(--mixtmt_echarts_footBallPlaygroundColor);
}
.comment {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  position: absolute;
  right: 10px;
  bottom: 5px;
  width: auto;
  height: 100%;
  font-size: 12px;
  font-weight: 700;
  & > div {
    margin-bottom: 5px;
  }
}
.number {
  // position: absolute;
  color: black;
}
.comment_t_vertical_scale {
  width: 100px;
  height: 23px;
  background-image: linear-gradient(269deg, #208f6f 0%, #8fdcc7 100%);
}
.comment_number {
  display: flex;
  justify-content: space-around;
  width: 100px;
}
.canvas {
  background-image: var(--mixtmt_ball_bg);
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
}

.right_img {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(114%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100px;
  height: 100%;
  font-size: 12px;
  color: #000000;
  text-align: left;
  .r_i_b {
    .r_i_b_vertical {
      display: flex;
      align-items: flex-end;
      margin-bottom: 2px;
      .r_i_b_vertical_text {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 83px;
      }
      .r_i_b_vertical_scale {
        width: 23px;
        height: 83px;
        margin-left: 2px;
        background-image: linear-gradient(179deg, #208f6f 0%, #8fdcc7 100%);
      }
    }
  }
}
</style>
